// extracted by mini-css-extract-plugin
export default {"keypad_tabs":"KeypadTabs_keypad_tabs__+MqAp","active":"KeypadTabs_active__dOALY"};